import React, { useRef, useCallback, useState } from "react";
import { Container } from "./styled";

const CanvasElement = ({
  children,
  handleMouseDown,
  handleTouchStart,
  handleResize,
  id,
  label,
  x,
  y,
  width,
  height,
  handleRightClick,
  handleLeftClick,
  boxShadow,
  isAnalitycsPage,
  handleImageSize,
}) => {
  const elementRef = useRef(null);
  const resizeRef = useRef(null);
  const [isResizing, setIsResizing] = useState(false);
  const touchTimeoutRef = useRef(null);

  const onResizeMouseDown = useCallback(
    (e) => {
      e.stopPropagation();
      setIsResizing(true);

      const startX = e.touches ? e.touches[0].clientX : e.clientX;
      const startY = e.touches ? e.touches[0].clientY : e.clientY;
      const startWidth = Number.parseInt(
        document.defaultView.getComputedStyle(elementRef.current).width,
        10
      );
      const startHeight = Number.parseInt(
        document.defaultView.getComputedStyle(elementRef.current).height,
        10
      );

      const onMove = (moveEvent) => {
        moveEvent.preventDefault();
        const clientX = moveEvent.touches
          ? moveEvent.touches[0].clientX
          : moveEvent.clientX;
        const clientY = moveEvent.touches
          ? moveEvent.touches[0].clientY
          : moveEvent.clientY;
        const newWidth = startWidth + clientX - startX;
        const newHeight = startHeight + clientY - startY;
        handleResize(id, newWidth, newHeight);
      };

      const onEnd = () => {
        setIsResizing(false);
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("touchmove", onMove, { passive: false });
        document.removeEventListener("mouseup", onEnd);
        document.removeEventListener("touchend", onEnd);
      };
      document.addEventListener("mousemove", onMove);
      document.addEventListener("touchmove", onMove, { passive: false });
      document.addEventListener("mouseup", onEnd);
      document.addEventListener("touchend", onEnd);
    },
    [handleResize, id, isResizing]
  );

  const onElementInteractionStart = (e) => {
    if (!isResizing) {
      if (e.type === "mousedown") {
        handleMouseDown(e, id);
      } else if (e.type === "touchstart") {
        handleTouchStart(e, id);
        touchTimeoutRef.current = setTimeout(() => {
          handleRightClick(e, id);
        }, 1500);
      }
    }
  };

  const onElementInteractionEnd = () => {
    clearTimeout(touchTimeoutRef.current);
  };

  const onElementInteractionMove = () => {
    clearTimeout(touchTimeoutRef.current);
  };

  return (
    <Container
      id={id}
      className={label}
      onContextMenu={(e) => handleRightClick(e, id)}
      ref={elementRef}
      onMouseDown={onElementInteractionStart}
      onTouchStart={onElementInteractionStart}
      onTouchEnd={onElementInteractionEnd}
      onTouchMove={onElementInteractionMove}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        left: `${x}px`,
        top: `${y}px`,
      }}
      onClick={handleLeftClick}
      boxShadow={boxShadow}
      isAnalitycsPage={isAnalitycsPage}
      onChange={(event) => handleImageSize({ event, id })}
    >
      {children}
      {!isAnalitycsPage ? (
        <div
          ref={resizeRef}
          className="resize-handle"
          onMouseDown={onResizeMouseDown}
          onTouchStart={onResizeMouseDown}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            class="Icon element-resize-handle"
          >
            <g fill="#8D929A" fill-rule="evenodd">
              <path
                fill="#1B2536"
                fill-opacity="0.5"
                d="M13.146 12.146a.5.5 0 0 1 .708.708l-1 1a.5.5 0 0 1-.708-.708zm0-4a.5.5 0 0 1 .708.708l-5 5a.5.5 0 0 1-.708-.708zm0-4a.5.5 0 0 1 .708.708l-9 9a.5.5 0 0 1-.708-.708z"
              />
              <path
                fill="#FFFFFF"
                fill-opacity="0.7"
                d="M13.146 6.146a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708-.708zm0-4a.5.5 0 0 1 .708.708l-11 11a.5.5 0 0 1-.708-.708zm0 8a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708-.708z"
              />
            </g>
          </svg>
        </div>
      ) : null}
    </Container>
  );
};

export default CanvasElement;
